import { createHOC } from 'vue-hoc';
import { get } from 'lodash';

import auth from '../../providers/auth';
import userManagement from '../../providers/userManagement';
import withUser from '../../hoc/withUser';
import withSubscriptionState from '../../hoc/withSubscriptionState';
import { canAccessOdin, getOdinHandoffUrl } from '../../utils/odin';

import SideNav from './SideNav.vue';

const options = {
  name: 'SideNavContainer',
  props: {
    user: {
      type: Object,
      required: true,
    },
    subscriptionState: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      state: {
        loading: false,
        error: null,
        isInOrg: false,
        isKeyOwner: false,
        isPendingInvitation: null,
      },
    };
  },
  async created() {
    this.fetchPending();
    this.state.isInOrg = await auth.isInOrg();
    this.state.isKeyOwner = await userManagement.isKeyOwner();
  },
  methods: {
    fetchPending() {
      userManagement.get(`invites/user/${this.user.user_id}`)
        .then(response => {
          const invites = get(response, 'data.invites', []).filter(
            invite => (invite.dismissed === false && invite.declined === false)
          );
          this.state.isPendingInvitation = (invites.length > 0);
        })
        .catch(err => {
          console.log(err);
        });
    },
  },
};

const renderWith = {
  props: {
    error() {
      return this.state.error;
    },
    loading() {
      return this.state.loading;
    },
    isInOrg() {
      return this.state.isInOrg;
    },
    isKeyOwner() {
      return this.state.isKeyOwner;
    },
    isOrgActive() {
      return !this.user['https://vrpatients.com/inactive'];
    },
    isAdmin() {
      const role = this.user.activeRole;
      return role === 'ADMIN' || role === 'SUPER_ADMIN';
    },
    isSuperAdmin() {
      const role = this.user.activeRole;
      return role === 'SUPER_ADMIN';
    },
    isStudent() {
      const role = this.user.activeRole;
      return role === 'STUDENT';
    },
    hasPaymentIssue() {
      return this.subscriptionState.hasPaymentIssue;
    },
    isPendingInvitation() {
      return this.state.isPendingInvitation;
    },
    showOdinButton() {
      return canAccessOdin(this.user) && !!getOdinHandoffUrl();
    },
    odinHandoffUrl() {
      return getOdinHandoffUrl();
    }
  },
};

const SideNavContainer = createHOC(SideNav, options, renderWith);
export default withUser()(withSubscriptionState()(SideNavContainer));
